"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _sortable = require("./sortable");

/**
 * PropTypes for the {@link sortable} HOC.
 *
 * @name sortablePropTypes
 * @type Object
 *
 *
 * @example
 *
 * function SortedPeopleList () { ... }
  * 
  * SortedPeopleList.propTypes = {
  *   ...sortablePropTypes,
  * }
  * 
*/
var _default = _sortable.sortablePropTypes;
exports["default"] = _default;